import { Box, Typography } from "@mui/material";
import { formatToNA } from "./Formatter";
import { grey } from "@mui/material/colors";

export default function DataLabel({ ...props }) {
    const { value, label, actions, noWrap, bottom = false, sx, align, gutterBottom = false, ...others } = props;
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', mb: gutterBottom ? 1 : null, ...sx }} {...others}>
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                {bottom &&
                    <>
                        <Typography component="div" noWrap={noWrap} align={align}>
                            {formatToNA(value)}
                        </Typography>
                        <Typography sx={{ color: grey[600] }} variant="body2" align={align}>
                            {label}
                        </Typography>
                    </>}
                {!bottom &&
                    <>
                        <Typography sx={{ color: grey[600] }} variant="body2" align={align}>
                            {label}
                        </Typography>
                        <Typography component="div" noWrap={noWrap} align={align}>
                            {formatToNA(value)}
                        </Typography>

                    </>}
            </Box>
            {actions &&
                <Box>
                    {actions}
                </Box>
            }
        </Box>)
}